import { RECIPES } from "../types/actions";

const initialState = {
	recipesResult: {},
	recipesSearchKeyword: null,
	availableFilters: [],
	recipeDetails: {},
	recipeFavorite: {},
	relatedRecipes: [],
	recipeNutritionFacts: [],
	recipeIngredients: [],
	recipeCommentsToApproveList: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case RECIPES.GET_RECIPES:
			return {
				...state,
				recipesResult: action.payload,
				recipesLoading: false
			};
		case RECIPES.GET_RECENT_RECIPES:
			return {
				...state,
				recentRecipesResult: action.payload
			};
		case RECIPES.GET_RECIPE_COMMENTS:
			return {
				...state,
				recipeCommentsResult: action.payload
			};
		case RECIPES.GET_RECIPE_COMMENTS_APPROVAL:
			return {
				...state,
				recipeCommentsToApproveList: action.payload
			};
		case RECIPES.RECIPE_DETAILS:
			return {
				...state,
				recipeDetails: action.payload
			};
		case RECIPES.SEARCH_RECIPES:
			return {
				...state,
				recipesSearchKeyword: action.payload
			};
		case RECIPES.GET_AVAILABLE_FILTERS:
			return {
				...state,
				availableFilters: action.payload
			};
		case RECIPES.RESET_RECIPES:
			return {
				...state,
				recipesResult: initialState.recipesResult
			};
		case RECIPES.RELATED_RECIPES:
			return {
				...state,
				relatedRecipes: action.payload
			};
		case RECIPES.RECIPE_NUTRITION_FACTS:
			return {
				...state,
				recipeNutritionFacts: action.payload
			};
		case RECIPES.RECIPE_INGREDIENTS:
			return {
				...state,
				recipeIngredients: action.payload
			};
		case RECIPES.GET_FEATURED_RECIPES:
			return {
				...state,
				featuredRecipes: action.payload
			};
		case RECIPES.GET_RECIPES_FAVORITED:
			return {
				...state,
				favoriteRecipes: action.payload
			};
		case RECIPES.RECIPE_IS_FAVOURITE:
			return {
				...state,
				recipeFavorite: action.payload
			};
		default:
			return state;
	}
};
